import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { Fragment, ReactNode } from 'react';
import { seoData } from './seoData';
// eslint-disable-next-line
import { useLocation } from '@reach/router';

type SeoProps = {
    pathname?: string;
    title?: string;
    description?: string;
    children?: ReactNode;
    keywords?: string;
    image?: IGatsbyImageData;
    shopifyImageUrl?: string;
};

export const Seo = ({
    pathname = '',
    title,
    description,
    children,
    keywords,
    image,
    shopifyImageUrl,
}: SeoProps) => {
    const { site, og } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                        keywords
                        siteUrl
                    }
                }
                og: file(relativePath: { eq: "default-og.png" }) {
                    childImageSharp {
                        gatsbyImageData(quality: 100, width: 990, height: 1292)
                    }
                }
            }
        `
    );

    const pageTitle = pathname.replaceAll('/', '');

    const location = useLocation();

    let siteUrl = site.siteMetadata.siteUrl;
    if (siteUrl.endsWith('/')) siteUrl = siteUrl.slice(0, -1);

    const theTitle = title
        ? title.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
        : seoData[pageTitle]
        ? seoData[pageTitle].t
        : site.siteMetadata.title;

    const metaDescription = description
        ? description.charAt(0).toUpperCase() + description.slice(1).toLowerCase()
        : seoData[pageTitle]
        ? seoData[pageTitle].d
        : site.siteMetadata.description;

    const theKeywords = keywords || site.siteMetadata.keywords;

    const imageData = image || og.childImageSharp.gatsbyImageData;
    const imageUrl = shopifyImageUrl || siteUrl + imageData.images.fallback.src;

    return (
        <Fragment>
            <html lang="en" />
            <title>{theTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={theKeywords} />
            <meta name="og:title" content={theTitle} />
            <meta name="og:description" content={metaDescription} />
            <meta name="og:type" content="website" />
            <meta name="og:image" content={imageUrl} />
            <meta name="og:url" content={site.siteMetadata.siteUrl + location.pathname} />
            <meta name="og:image:width" content={imageData.width} />
            <meta name="og:image:height" content={imageData.height} />
            <meta
                name="google-site-verification"
                content="EzPs6p-URcp98UfhSDAXoV2w-7U1lWcdETqJo8_RykA"
            />
            {children}
        </Fragment>
    );
};
